import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-error-default',
  templateUrl: './error-default.component.html',
  styleUrls: ['./error-default.component.scss'],
})
export class ErrorDefaultComponent {
  @Input()
  public set error(data) {
    this.data = data;
    this.title = data?.title || 'error';
    this.message = data?.message || 'unknown error has ocurred';
  }

  public data: any = {};
  public title: string;
  public message: string;
}
